import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const STORAGE_KEY = "cs-molbio-consent";
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-8EW8CWD7DG";
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

function applyConsent(granted) {
  const value = granted ? "granted" : "denied";
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: value,
      ad_user_data: value,
      ad_personalization: value,
      analytics_storage: value,
    });
  } else {
    gtag("consent", "update", {
      ad_storage: value,
      ad_user_data: value,
      ad_personalization: value,
      analytics_storage: value,
    });
  }

  if (granted) {
    loadGoogleTags();
  }
}

function loadGoogleTags() {
  const ids = [GA_ID, ADS_ID].filter(Boolean);
  if (!ids.length || document.getElementById("cs-molbio-gtag")) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };

  const script = document.createElement("script");
  script.id = "cs-molbio-gtag";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ids[0]}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  ids.forEach((id) => window.gtag("config", id));
}

const CookieConsent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      setVisible(true);
      return;
    }
    applyConsent(stored === "granted");
  }, []);

  const choose = (granted) => {
    window.localStorage.setItem(STORAGE_KEY, granted ? "granted" : "denied");
    applyConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={t("cookie-title")}
      style={{
        position: "fixed",
        left: 16,
        right: 16,
        bottom: 16,
        zIndex: 1080,
        maxWidth: 720,
        margin: "0 auto",
        background: "#12263f",
        color: "#fff",
        padding: "20px 24px",
        borderRadius: 8,
      }}
    >
      <h2 style={{ fontSize: 18, marginBottom: 8 }}>{t("cookie-title")}</h2>
      <p style={{ fontSize: 14, marginBottom: 16 }}>
        {t("cookie-text")}{" "}
        <Link to="/privacy-policy" style={{ color: "#8ec5ff" }}>
          {t("privacy-policy")}
        </Link>
        .
      </p>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <button type="button" className="default-btn" onClick={() => choose(true)}>
          {t("cookie-accept")}
        </button>
        <button
          type="button"
          className="default-btn-two"
          onClick={() => choose(false)}
        >
          {t("cookie-reject")}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
